import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSnackbar } from "notistack";
// import { FaTrash } from "react-icons/fa";
// import { MdEditSquare } from "react-icons/md";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import AdminLoader from "../../components/common/loader/AdminLoader";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import {
  addHardware,
  deleteHardware,
  fetchHardware,
  importHardwareFromExcel,
  updateHardware,
} from "../../store/slices/hardwareSlice";
import { getAllAssemblyInventory } from "../../store/slices/assemblyInventorySlice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import CommaConvert from "../../utils/CommaConvert";
import { useCurrencySymbol } from "../../utils/currencyUtils";
import { SquarePen, Trash2, Download, Upload } from "lucide-react";
import { useLoggedUser } from "../../utils/useLoggedUser";
import { getFeatureAccessLevel } from "../../utils/featureAccessUtils";

const Hardware = () => {
  const currency = useCurrencySymbol();
  const loggedUser = useLoggedUser();
  const hasNoFeatureConfig = !loggedUser?.featureAccess || loggedUser.featureAccess.length === 0;
  const subpartAddLevel = getFeatureAccessLevel(loggedUser, "HARDWARE PARTS ADD HARDWARE PARTS");
  const subpartEditLevel = getFeatureAccessLevel(loggedUser, "HARDWARE PARTS EDIT HARDWARE PARTS");
  const subpartDownloadLevel = getFeatureAccessLevel(loggedUser, "HARDWARE PARTS DOWNLOAD HARDWARE PARTS");
  const subpartUploadLevel = getFeatureAccessLevel(loggedUser, "HARDWARE PARTS UPLOAD HARDWARE PARTS");
  const subpartAccessLevel = subpartAddLevel || subpartEditLevel || subpartDownloadLevel || subpartUploadLevel;
  const isViewOnly = !hasNoFeatureConfig && subpartAccessLevel &&
    String(subpartAccessLevel).trim().toUpperCase() === "VIEW ONLY";
  console.log("Subpart isViewOnly:", isViewOnly, "accessLevel:", subpartAccessLevel, "hasNoFeatureConfig:", hasNoFeatureConfig);

  // "NO ACCESS" for *add* must disable the add form even when other permissions exist.
  const isSubpartAddNoAccess =
    !hasNoFeatureConfig &&
    subpartAddLevel &&
    String(subpartAddLevel).trim().toUpperCase() === "NO ACCESS";

  const USAComma = CommaConvert();
  const downloadExcel = () => {
    if (isViewOnly) return;
    if (!selectedAssembly) {
      enqueueSnackbar("Please Select Assembly Name First", {
        variant: "error",
      });
      return;
    }
    const headings = [
      {
        "Part Name": "",
        "Part Number": "",
        "Unit Per Assembly": "",
        [`Unit Cost(${currency})`]: "",
        "Unit Available": "",
        "Minimum Quantity": "",
        "Order Quantity": "",
        Group: selectedSidebarGroupName || SidebarGroup,
        "Supplier Name": "",
        "Assembly Name": selectedAssembly,
      },
    ];

    const ws = XLSX.utils.json_to_sheet(headings, { skipHeader: false });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample File");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(excelFile, "Sample.xlsx");
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentPageTitle("Subpart"));
  }, [dispatch]);

  const { enqueueSnackbar } = useSnackbar();
  const hardwareData = useSelector((state) => state.hardware.data);
  const [filteredHardwareTypes, setFilteredHardwareTypes] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [partdescription, setPartdescription] = useState("");
  const [partNumber, setPartNumber] = useState("");
  const [unitperassembly, setunitperassembly] = useState("");
  const [unitavailable, setunitavailable] = useState("");
  const [minimumquantity, setminimumquantity] = useState("");
  const [orderingquantity, setorderingquantity] = useState("");
  const [threshold, setThreshold] = useState("");
  const [suppliername, setsuppliername] = useState("");

  const [unitPrice, setUnitPrice] = useState("");
  const [, setExcelData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editingHardwareId, setEditingHardwareId] = useState(null);
  const isAddNoAccess = isSubpartAddNoAccess && !editingHardwareId; // only block "Add" mode
  const isFormDisabled = isViewOnly || isAddNoAccess;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sourceToDelete, setSourceToDelete] = useState(null);
  const SidebarGroup = useSelector((state) => state.sidebar.SidebarGroup);
  const groupsFromSlice = useSelector((state) => state.group?.group || []);
  const selectedSidebarGroupName = useMemo(() => {
    const selectedId = String(SidebarGroup || "").trim();
    if (!selectedId) return "";
    const matchedGroup = (Array.isArray(groupsFromSlice) ? groupsFromSlice : []).find((groupItem) => {
      const id = String(groupItem?._id ?? groupItem?.id ?? "").trim();
      return id === selectedId;
    });
    return String(
      matchedGroup?.name ??
      matchedGroup?.newGroupName ??
      matchedGroup?.groupName ??
      selectedId
    ).trim();
  }, [SidebarGroup, groupsFromSlice]);
  const isMatchingSidebarGroup = useCallback(
    (groupValue) => {
      if (!SidebarGroup) return true;
      const normalizedGroupValue = String(groupValue ?? "").trim();
      return (
        normalizedGroupValue === String(SidebarGroup).trim() ||
        normalizedGroupValue === selectedSidebarGroupName
      );
    },
    [SidebarGroup, selectedSidebarGroupName]
  );
  const getItemGroupValue = useCallback((item) => {
    return item?.groupid ?? item?.groupId ?? item?.group;
  }, []);
  const [InventoryData, setInventoryData] = useState([]);
  const [selectedAssembly, setSelectedAssembly] = useState("");
  const dropdownsRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const { inventory } = useSelector((state) => state.assemblyInventory);

  console.log("InventoryData", InventoryData);
  console.log("inventory from Redux:", inventory);
  useEffect(() => {
    // Handle both array and object with data property
    let inventoryArray = inventory;
    if (inventory && typeof inventory === 'object' && !Array.isArray(inventory) && inventory.data && Array.isArray(inventory.data)) {
      inventoryArray = inventory.data;
    }
    
    // Only filter if inventory is an array
    if (Array.isArray(inventoryArray)) {
      const selectedinventory = inventoryArray.filter(
        (item) => item && isMatchingSidebarGroup(getItemGroupValue(item))
      );
      setInventoryData(selectedinventory);
    } else {
      setInventoryData([]);
    }
  }, [inventory, SidebarGroup, isMatchingSidebarGroup, getItemGroupValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
      if (
        openDropdownId &&
        dropdownsRef.current &&
        !dropdownsRef.current.contains(event.target)
      ) {
        // Also check if the click was on the ellipsis icon itself
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest(".dropdown-toggle-icon");

        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  console.log("ghdfhfdh", SidebarGroup);
  useEffect(() => {
    dispatch(fetchHardware());
    dispatch(getAllAssemblyInventory());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!hardwareData?.data) return;

  //   // First, filter by SidebarGroup
  //   const groupFilteredData = hardwareData.data.filter(item => item.group === SidebarGroup);

  //   // Then apply search filter if search query exists
  //   let filteredData = groupFilteredData;

  //   if (searchQuery.trim() !== "") {
  //     filteredData = groupFilteredData.filter((hardware) => {
  //       const query = searchQuery.toLowerCase().trim();

  //       // Search across multiple fields
  //       return (
  //         (hardware.partdescription?.toLowerCase().includes(query)) ||
  //         (hardware.partnumber?.toString().toLowerCase().includes(query)) ||
  //         (hardware.unitprice?.toString().toLowerCase().includes(query)) ||
  //         (hardware.unitavailable?.toString().toLowerCase().includes(query)) ||
  //         (hardware.minimumquantity?.toString().toLowerCase().includes(query)) ||
  //         (hardware.orderquantity?.toString().toLowerCase().includes(query)) ||
  //         (hardware.suppliername?.toLowerCase().includes(query))
  //       );
  //     });
  //   }

  //   setFilteredHardwareTypes(filteredData);
  // }, [searchQuery, hardwareData, SidebarGroup]);

  // Update this useEffect to also filter by selectedAssembly
  useEffect(() => {
    // Handle both array and object with data property
    let dataArray = null;
    
    if (Array.isArray(hardwareData)) {
      dataArray = hardwareData;
    } else if (hardwareData && typeof hardwareData === 'object' && hardwareData.data && Array.isArray(hardwareData.data)) {
      dataArray = hardwareData.data;
    }
    
    // Debug: log the data structure to help identify issues
    if (hardwareData && !dataArray) {
      console.log("Hardware data structure issue - hardwareData:", hardwareData);
    }
    
    if (!dataArray || !Array.isArray(dataArray)) {
      setFilteredHardwareTypes([]);
      return;
    }

    // Show table data only after assembly is selected from the form.
    if (!selectedAssembly || selectedAssembly.trim() === "") {
      setFilteredHardwareTypes([]);
      return;
    }

    // First, filter by SidebarGroup and selected assembly
    let groupFilteredData = dataArray.filter(
      (item) => isMatchingSidebarGroup(getItemGroupValue(item)) && item.assemblyname === selectedAssembly
    );

    // Then apply search filter if search query exists
    let filteredData = groupFilteredData;

    if (searchQuery.trim() !== "") {
      filteredData = groupFilteredData.filter((hardware) => {
        const query = searchQuery.toLowerCase().trim();

        // Search across multiple fields
        return (
          hardware.partdescription?.toLowerCase().includes(query) ||
          hardware.partnumber?.toString().toLowerCase().includes(query) ||
          hardware.unitperassembly?.toString().toLowerCase().includes(query) ||
          hardware.unitprice?.toString().toLowerCase().includes(query) ||
          hardware.unitavailable?.toString().toLowerCase().includes(query) ||
          hardware.minimumquantity?.toString().toLowerCase().includes(query) ||
          hardware.orderquantity?.toString().toLowerCase().includes(query) ||
          hardware.suppliername?.toLowerCase().includes(query)
        );
      });
    }

    setFilteredHardwareTypes(filteredData);
  }, [searchQuery, hardwareData, SidebarGroup, selectedAssembly, isMatchingSidebarGroup, getItemGroupValue]); // Change to filterAssembly

  const handlepartdescription = (e) => {
    if (isFormDisabled) return;
    setPartdescription(e.target.value);
  };

  const handleFileChange = async (e) => {
    if (isViewOnly) return;
    const file = e.target.files[0];
    if (file) {
      const validTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!validTypes.includes(file.type)) {
        enqueueSnackbar("Please upload a valid Excel file (.xls or .xlsx)", {
          variant: "error",
        });
        e.target.value = "";
        return;
      }

      setExcelData(file);
      const result = await dispatch(importHardwareFromExcel(file));

      if (importHardwareFromExcel.fulfilled.match(result)) {
        enqueueSnackbar("Excel File Data Added Successfully", {
          variant: "success",
        });
        dispatch(fetchHardware());
      } else {
        enqueueSnackbar("Failed to import Excel file.", { variant: "error" });
      }
      setExcelData(null);
    }
  };

  const Submit = async () => {
    if (isFormDisabled) return;
    if (
      !partdescription ||
      !partNumber ||
      !unitPrice ||
      !unitavailable ||
      !minimumquantity ||
      !orderingquantity ||
      !selectedAssembly ||
      !unitperassembly
    ) {
      enqueueSnackbar("Please fill all the fields!", { variant: "error" });
      return;
    }
    if (minimumquantity === "0" || minimumquantity === 0 || Number(minimumquantity) === 0) {
      enqueueSnackbar("Minimum Quantity can't be zero.", { variant: "error" });
      return;
    }

    const hardwareStoreData = {
      partdescription: partdescription,
      partnumber: partNumber,
      unitperassembly: Number(unitperassembly),
      unitprice: Number(unitPrice),
      unitavailable: Number(unitavailable),
      minimumquantity: Number(minimumquantity),
      orderquantity: Number(orderingquantity),
      threshold: threshold ? Number(threshold) : 0,
      groupid: SidebarGroup,
      suppliername: suppliername,
      assemblyname: selectedAssembly,
    };

    console.log("Sending hardware data:", hardwareStoreData);
    console.log("Selected Assembly:", selectedAssembly);

    setIsLoading(true);
    try {
      if (!editingHardwareId) {
        await dispatch(addHardware(hardwareStoreData)).unwrap();
        enqueueSnackbar("Hardware Details Added Successfully", {
          variant: "success",
        });
      } else {
        await dispatch(
          updateHardware({
            id: editingHardwareId,
            updatedData: hardwareStoreData,
          })
        ).unwrap();
        enqueueSnackbar("Hardware Details Updated Successfully", {
          variant: "success",
        });
      }

      dispatch(fetchHardware());
      setPartdescription("");
      setPartNumber("");
      setunitperassembly("");
      setUnitPrice("");
      setunitavailable("");
      setminimumquantity("");
      setEditingHardwareId(null);
      setorderingquantity("");
      setThreshold("");
      setsuppliername("");
    } catch (error) {
      // Error will be what rejectWithValue returned
      if (error?.message) {
        enqueueSnackbar(error.message, { variant: "error" });
      } else {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleHardwareEdit = (hard) => {
    if (isViewOnly) return;
    setEditingHardwareId(hard?._id);
    setPartdescription(hard?.partdescription);
    setPartNumber(hard?.partnumber);
    setunitperassembly(hard?.unitperassembly || "");
    setUnitPrice(hard?.unitprice);
    setunitavailable(hard?.unitavailable);
    setminimumquantity(hard?.minimumquantity);
    setorderingquantity(hard?.orderquantity);
    setThreshold(hard?.threshold || "");
    setsuppliername(hard?.suppliername);
    setSelectedAssembly(hard?.assemblyname || "");
  };

  const Cancel = (e) => {
    e.preventDefault();
    setPartdescription("");
    setPartNumber("");
    setunitperassembly("");
    setUnitPrice("");
    setunitavailable("");
    setminimumquantity("");
    setEditingHardwareId(null);
    setsuppliername("");
    setorderingquantity("");
    setThreshold("");
    setSelectedAssembly("");
  };

  const handleHardwareDelete = (hard) => {
    if (isViewOnly) return;
    setSourceToDelete(hard._id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setSourceToDelete(null);
  };

  const confirmDelete = async () => {
    if (sourceToDelete) {
      await dispatch(deleteHardware(sourceToDelete));
      dispatch(fetchHardware());
      enqueueSnackbar("Hardware Details Deleted Successfully", {
        variant: "success",
      });
    }
    closeDeleteModal();
  };

  // useEffect(() => {
  //   if (searchQuery.trim() === "") {
  //     setFilteredHardwareTypes(filteredHardwareTypes);
  //   } else {
  //     const filtered = filteredHardwareTypes.filter((hardware) => {
  //       // Convert all searchable fields to strings for case-insensitive comparison
  //       const partDescription = hardware.partdescription
  //         ? hardware.partdescription.toLowerCase()
  //         : "";
  //       const partNumber = hardware.partnumber
  //         ? hardware.partnumber.toString().toLowerCase()
  //         : "";
  //       const unitPrice = hardware.unitprice
  //         ? hardware.unitprice.toString().toLowerCase()
  //         : "";

  //       const query = searchQuery.toLowerCase();

  //       return (
  //         partDescription.includes(query) ||
  //         partNumber.includes(query) ||
  //         unitPrice.includes(query)
  //       );
  //     });
  //     setFilteredHardwareTypes(filtered);
  //   }
  // }, [searchQuery, filteredHardwareTypes]);

  const sortData = (field, order) => {
    const sortedData = [...filteredHardwareTypes].sort((a, b) => {
      // For string fields
      if (
        field === "partdescription" ||
        field === "suppliername" ||
        field === "partnumber"
      ) {
        const valueA = (a[field] || "").toString().toLowerCase();
        const valueB = (b[field] || "").toString().toLowerCase();

        if (order === "az" || order === "asc") {
          return valueA.localeCompare(valueB);
        } else {
          return valueB.localeCompare(valueA);
        }
      }

      // For numeric fields - ensure we use the correct field names from your data
      let numericValueA, numericValueB;

      switch (field) {
        case "unitprice":
          numericValueA = parseFloat(a.unitprice) || 0;
          numericValueB = parseFloat(b.unitprice) || 0;
          break;
        case "unitavailable":
          numericValueA = parseFloat(a.unitavailable) || 0;
          numericValueB = parseFloat(b.unitavailable) || 0;
          break;
        case "unitperassembly":
          numericValueA = parseFloat(a.unitperassembly) || 0;
          numericValueB = parseFloat(b.unitperassembly) || 0;
          break;
        case "minimumquantity":
          numericValueA = parseFloat(a.minimumquantity) || 0;
          numericValueB = parseFloat(b.minimumquantity) || 0;
          break;
        case "orderquantity":
          numericValueA = parseFloat(a.orderquantity) || 0;
          numericValueB = parseFloat(b.orderquantity) || 0;
          break;
        default:
          return 0;
      }

      if (order === "asc" || order === "az") {
        return numericValueA - numericValueB;
      } else {
        return numericValueB - numericValueA;
      }
    });

    setFilteredHardwareTypes(sortedData);
  };
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="bg-[#f3f8f8] pb-6 h-full">
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />
      {isLoading && <AdminLoader isLoading={isLoading} />}
      <div className="relative flex justify-center align-middle items-center pt-2">
        <div className="flex w-[95%] gap-4">
          {/* FORM */}
          <div className="w-[35%] bg-white rounded-md h-fit">
            <div className="flex px-3 py-4 gap-2 align-middle items-center border-b">
              <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
              <h2 className="font-semibold text-xl">
                {editingHardwareId ? "Edit Subpart" : "Add Subpart"}: {selectedSidebarGroupName || SidebarGroup}
              </h2>
            </div>
            <fieldset disabled={isFormDisabled} className={isFormDisabled ? "opacity-90" : ""}>
            <div className="mainform px-3 py-2 flex flex-col gap-3">
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Assembly Name <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <select
                    className={`border w-full text-xs border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "cursor-pointer bg-[#fcfcfc]"}`}
                    value={selectedAssembly}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (e.target.value === "all") {
                        setSelectedAssembly();
                      } else {
                        setSelectedAssembly(e.target.value);
                      }
                    }}
                  >
                    <option value="all">All</option>
                    <option value="" disabled hidden>
                      Select Assembly
                    </option>
                    {InventoryData.length > 0 ? (
                      InventoryData?.map((item) => (
                        <option key={item._id} value={item.assembly}>
                          {item.assembly}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Assembly Found</option>
                    )}
                  </select>
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Part Name <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Part Name"
                    value={partdescription}
                    disabled={isFormDisabled}
                    onChange={handlepartdescription}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Unit Per Assembly Required <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Unit Per Assembly Required"
                    value={unitperassembly}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) {
                        setunitperassembly(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Part Number <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Part Number"
                    value={partNumber}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      const val = e.target.value;
                      if (/^[a-zA-Z0-9]*$/.test(val)) {
                        setPartNumber(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Unit Available <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Unit Available"
                    value={unitavailable}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      const val = e.target.value;
                      if (/^-?\d*\.?\d{0,2}$/.test(val) || val === "" || val === "-") {
                        setunitavailable(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Unit Cost ({currency}) <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="0"
                    value={USAComma(unitPrice)}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      setUnitPrice(
                        e.target.value
                          .split(".")[0]
                          .replace(/,/g, "")
                          .replace(/\D/g, "")
                      );
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Minimum Quantity <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Minimum Quantity"
                    value={minimumquantity}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val)) {
                        setminimumquantity(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Ordering Quantity <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    required
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Ordering Quantity"
                    value={orderingquantity}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val)) {
                        setorderingquantity(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Threshold %
                </div>
                <div>
                  <input
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs cursor-not-allowed ${isFormDisabled ? "bg-[#f3f4f6] text-[#9ca3af]" : "bg-gray-100"}`}
                    type="text"
                    placeholder="Threshold %"
                    value={threshold}
                    readOnly
                    disabled={isFormDisabled}
                  />
                </div>
              </div>
              <div>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  Supplier Name
                </div>
                <div>
                  <input
                    className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                    type="text"
                    placeholder="Enter Supplier Name"
                    value={suppliername}
                    disabled={isFormDisabled}
                    onChange={(e) => {
                      if (isFormDisabled) return;
                      setsuppliername(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex gap-2 text-xs">
                <button
                  onClick={Submit}
                  disabled={isFormDisabled}
                  className={`p-1 flex align-middle items-center gap-2 px-4 overflow-hidden rounded-lg ${isFormDisabled ? "opacity-60 cursor-not-allowed pointer-events-none bg-gray-300 text-[#9ca3af]" : "bg-[#0f61e6] hover:bg-blue-400 text-white"}`}
                >
                  {editingHardwareId ? "Update" : "Submit"}
                </button>
                <button
                  onClick={Cancel}
                  disabled={isFormDisabled}
                  className={`py-2 px-3 border overflow-hidden rounded-lg ${isFormDisabled ? "opacity-60 cursor-not-allowed pointer-events-none border-gray-300 bg-gray-100 text-[#9ca3af]" : "border-[#e5e7eb] bg-white"}`}
                >
                  Cancel
                </button>
              </div>
            </div>
            </fieldset>
          </div>

          {/* TABLE */}
          <div className="w-[65%] p-4 bg-white rounded-md">
            <div className="flex justify-between align-middle items-center py-2 gap-3">
              <div className="flex items-center gap-3 shrink-0">
                <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                <h1 className="text-lg font-semibold text-gray-900">
                  {selectedAssembly ? (
                    <>Subpart Details: {selectedSidebarGroupName || SidebarGroup} ({selectedAssembly})</>
                  ) : (
                    <>Subpart Details: {selectedSidebarGroupName || SidebarGroup}</>
                  )}
                </h1>
              </div>

              <div className="flex items-center gap-3 flex-wrap justify-end">
                <button
                  onClick={downloadExcel}
                  disabled={isViewOnly}
                  className={`text-xs flex items-center justify-center px-3 py-2 rounded-lg ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none bg-gray-300 text-[#9ca3af]" : "bg-[#0f61e6] hover:bg-blue-400 text-white"}`}
                  title="Download Template"
                >
                  <Download size={16} />
                </button>

                <input
                  type="file"
                  accept=".xls,.xlsx"
                  id="excel-upload"
                  onChange={handleFileChange}
                  disabled={isViewOnly}
                  className="hidden"
                />

                <label
                  htmlFor={isViewOnly ? undefined : "excel-upload"}
                  className={`text-xs flex items-center justify-center px-3 py-2 border rounded-lg ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none border-gray-300 bg-gray-100 text-[#9ca3af]" : "border-[#e5e7eb] bg-white cursor-pointer hover:bg-gray-50"}`}
                  title="Upload File"
                >
                  <Upload size={16} />
                </label>

                <p className="text-xs text-red-700 whitespace-nowrap">
                (.xls/.xlsx)
                </p>

                <div className="flex gap-1 p-1 align-middle items-center border border-[#e5e7eb] rounded-lg w-[90px]">
                  <MdSearch className="w-4 h-4 text-gray-500" />
                  <input
                    type="text"
                    placeholder="Search"
                    className="outline-none text-xs text-gray-900 placeholder-gray-500 w-full"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />
                </div>
              </div>
            </div>
            <hr />
            <hr />
            <br />
            <div className="maintable min-h-[10rem] max-h-[60vh] overflow-auto">
              <table className="min-w-full divide-y divide-gray-200 border text-xs">
                <thead className="bg-[#e8e8e8] sticky top-0 z-50 font-semibold">
                  <tr>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize">Sr. No</th>
                    <th className="border p-2 text-start tracking-wider font-medium capitalize relative">
                      <div className="flex justify-between items-center">
                        <span>Part Name</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("partdescription", "az")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("partdescription", "za")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Part Number</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("partnumber", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("partnumber", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Units per assembly</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("unitperassembly", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("unitperassembly", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Unit Available</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("unitavailable", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("unitavailable", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Unit Cost ({currency})</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("unitprice", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("unitprice", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Minimum Quantity</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("minimumquantity", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("minimumquantity", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                      <div className="flex justify-center items-center gap-2">
                        <span>Ordering Quantity</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("orderquantity", "asc")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("orderquantity", "desc")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-start tracking-wider font-medium capitalize relative">
                      <div className="flex justify-between items-center">
                        <span>Supplier Name</span>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => sortData("suppliername", "az")}
                          >
                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => sortData("suppliername", "za")}
                          >
                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th className="border p-2 text-center tracking-wider font-medium capitalize">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredHardwareTypes && filteredHardwareTypes.length > 0 ? (
                    filteredHardwareTypes?.map((hard, index) => (
                      <tr className="border border-gray-400" key={hard._id || index}>
                        <td className="px-2 border-b text-center py-2">{index + 1}</td>
                        <td className="px-2 text-start border-b py-2">{hard?.partdescription}</td>
                        <td className="px-2 text-center border-b py-2">{hard?.partnumber}</td>
                        <td className="px-2 text-center border-b py-2">{USAComma(hard?.unitperassembly) || " "}</td>
                        <td className={`px-2 text-center border-b py-2 ${parseInt(hard?.unitavailable) < 0 ? 'text-red-500' : ''}`}>
                          {USAComma(hard?.unitavailable)}
                        </td>
                        <td className="px-2 text-center border-b py-2">{USAComma(hard?.unitprice)}</td>
                        <td className="px-2 text-center border-b py-2">{USAComma(hard?.minimumquantity)}</td>
                        <td className="px-2 text-center border-b py-2">
                          {hard?.orderquantity ? USAComma(hard?.orderquantity) : " "}
                        </td>
                        <td className="px-2 text-start border-b py-2">{hard?.suppliername || " "}</td>
                        <td className="px-2 border-b text-center py-2">
                          <div className="flex justify-center items-center gap-3">
                            <div
                              onClick={() => handleHardwareEdit(hard)}
                              className={isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none" : "cursor-pointer hover:opacity-70"}
                              title="Edit"
                            >
                              <SquarePen size={18} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                            </div>
                            <div
                              onClick={() => handleHardwareDelete(hard)}
                              className={isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none" : "cursor-pointer hover:opacity-70"}
                              title="Delete"
                            >
                              <Trash2 size={18} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center text-red-500 py-4">
                        {searchQuery.trim() === ""
                          ? "No Hardware available"
                          : "No matching Hardware found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hardware;
